import { render, staticRenderFns } from "./ordeHistoryr.vue?vue&type=template&id=9864cae0&scoped=true"
import script from "./ordeHistoryr.vue?vue&type=script&lang=js"
export * from "./ordeHistoryr.vue?vue&type=script&lang=js"
import style0 from "./ordeHistoryr.vue?vue&type=style&index=0&id=9864cae0&prod&lang=css"
import style1 from "./ordeHistoryr.vue?vue&type=style&index=1&id=9864cae0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9864cae0",
  null
  
)

export default component.exports